import { useMetricsStore } from '../stores/metrics.store'
import { dbgEvent } from '../lib/debug'

// Types pour les events metrics extraits du canal terminal
interface SystemInitEvent {
  type: 'system_init'
  model: string
  [key: string]: unknown
}

interface ResultEvent {
  type: 'result'
  totalCostUsd: number
  [key: string]: unknown
}

type MetricsEvent = SystemInitEvent | ResultEvent

export const metricsHandler = {
  onMetricsEvent(sessionId: string, data: MetricsEvent): void {
    if (data.type === 'system_init') {
      dbgEvent('Zustand', 'metrics.onMetricsEvent system_init', { sessionId: sessionId.slice(0, 8), model: data.model })
      useMetricsStore.getState().setModel(sessionId, data.model)
    } else if (data.type === 'result') {
      dbgEvent('Zustand', 'metrics.onMetricsEvent result', { sessionId: sessionId.slice(0, 8), cost: data.totalCostUsd })
      useMetricsStore.getState().setCost(sessionId, data.totalCostUsd)
    }
  },
}
